'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var limiter = require('limiter');

var RateLimiter =
/*#__PURE__*/
function () {
  function RateLimiter(rateLimit) {
    _classCallCheck(this, RateLimiter);

    this._rateLimit = parseInt(rateLimit);
    this._limiter = new limiter.RateLimiter(this._rateLimit, 'second');
    this._tokensRequested = 0;
    this._prevWindowRate = null;
  }

  _createClass(RateLimiter, [{
    key: "isAllowed",
    value: function isAllowed() {
      var curIntervalStart = this._limiter.curIntervalStart;

      var allowed = this._isAllowed();

      if (curIntervalStart !== this._limiter.curIntervalStart) {
        this._prevWindowRate = this._currentWindowRate();
        this._tokensRequested = 0;
      }

      this._tokensRequested++;
      return allowed;
    }
  }, {
    key: "effectiveRate",
    value: function effectiveRate() {
      var currentWindowRate = this._currentWindowRate();

      if (this._prevWindowRate === null) return currentWindowRate;
      return (currentWindowRate + this._prevWindowRate) / 2;
    }
  }, {
    key: "_isAllowed",
    value: function _isAllowed() {
      if (this._rateLimit < 0) return true;
      if (this._rateLimit === 0) return false;
      return this._limiter.tryRemoveTokens(1);
    }
  }, {
    key: "_currentWindowRate",
    value: function _currentWindowRate() {
      if (this._rateLimit < 0) return 1;
      if (this._rateLimit === 0) return 0;
      if (this._tokensRequested === 0) return 1;
      return this._limiter.tokensThisInterval / this._tokensRequested;
    }
  }]);

  return RateLimiter;
}();

module.exports = RateLimiter;